"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../../../theme/styled-components"));

var INDENT = '1.5em';
var FONT_SIZE = '0.9em';
var INPUT_PADDING = '0.2em 0.5em';
var Indent = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  position: relative;\n"], ["\n  width: ", ";\n  position: relative;\n"])), INDENT);
var SectionItem = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  ", ";\n"])), function (_a) {
  var ghost = _a.ghost;
  return ghost && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: #b9b9b9;\n      transition: 0.2s color;\n      &:hover {\n        color: #000;\n      }\n    "], ["\n      color: #b9b9b9;\n      transition: 0.2s color;\n      &:hover {\n        color: #000;\n      }\n    "])));
});
var SectionMarker = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-left: 0;\n  font-size: ", ";\n  padding: ", ";\n"], ["\n  margin-left: 0;\n  font-size: ", ";\n  padding: ", ";\n"])), FONT_SIZE, INPUT_PADDING);
var Title = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var SectionText = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1 0 0;\n  font-size: ", ";\n  padding: ", ";\n"], ["\n  flex: 1 0 0;\n  font-size: ", ";\n  padding: ", ";\n"])), FONT_SIZE, INPUT_PADDING);
var Intro = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), FONT_SIZE);

var C = function C(_a) {
  var _b = _a.data,
      sections = _b.sections,
      paragraph_nr = _b.paragraph_nr,
      text = _b.text,
      title = _b.title;

  function renderSections(sections, path, level) {
    if (path === void 0) {
      path = [];
    }

    if (level === void 0) {
      level = 1;
    }

    return React.createElement(React.Fragment, null, sections.map(function (section, idx) {
      return React.createElement(React.Fragment, {
        key: idx.toString()
      }, React.createElement(SectionItem, null, Array(level).fill(0).map(function (i, iidx) {
        return React.createElement(Indent, {
          key: iidx.toString()
        });
      }), React.createElement(SectionMarker, null, section.marker), React.createElement(SectionText, null, section.text)), section.sections && section.sections.length > 0 && renderSections(section.sections, __spreadArrays(path, ['sections', idx]), level + 1), (!section.sections || section.sections.length === 0) && React.createElement(SectionItem, {
        ghost: true
      }, Array(level + 1).fill(0).map(function (i, iidx) {
        return React.createElement(Indent, {
          key: iidx.toString()
        });
      })));
    }), React.createElement(SectionItem, {
      ghost: true
    }, Array(level).fill(0).map(function (i, iidx) {
      return React.createElement(Indent, {
        key: iidx.toString()
      });
    })));
  }

  return React.createElement(React.Fragment, null, React.createElement(Title, null, "\xA7 ", paragraph_nr, " ", title), React.createElement(Intro, null, text), renderSections(sections || []));
};

exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;